// extracted by mini-css-extract-plugin
export default {"gradeScaleLegend":"gradeScaleLegend-kVR9h","gradeColor":"gradeColor-NKTk6","gradeDescription":"gradeDescription-Z6jyM","legendsWrapper":"legendsWrapper-IxB4H"};